import { Panel, PanelBody, PanelGrid, PanelGridAmount, PanelGridItem } from 'components';
import { CreditInfoData } from 'types';
import styles from './CreditInfo.module.scss';

type Props = {
    creditInfo: CreditInfoData
}

export default function CreditInfo({ creditInfo }: Props) {

    return (
        <Panel className={styles.panel}>
            <PanelBody className={styles.body}>
                <PanelGrid className={styles.grid}>
                    <div className={styles.gridItem}>
                    <PanelGridAmount
                            label={"Amount: "}
                            value={creditInfo.creditAmount}
                        />
                    </div>
                    <div className={styles.gridItem}>
                    <PanelGridItem
                            label={"Credit Number: "}
                            value={creditInfo.creditNumber}
                        />
                    </div>
                    <div className={styles.gridItem}>
                    <PanelGridItem
                            label={"Voucher ID: "}
                            value={creditInfo.voucherId}
                        />
                    </div>
                </PanelGrid>

            </PanelBody>
        </Panel>
    )
}